<template>
<v-container pa-5 style="background-color:#f3f3f3; padding:3px; height:100%"  flat>
        <v-row >
          <v-col cols="12" align="center"><h1 class="font-weight-light">I tuoi pagamenti</h1></v-col>
        </v-row >
        <v-row v-if="righe.length > 0">
          <v-col cols="12" align="center"><h5 class="font-weight-light">Premi il pulsante verde per effetture il pagamento</h5></v-col>

        </v-row >
    


    <v-skeleton-loader
        ref="skeleton"
        type="card"
        class="mx-auto"
        :loading="loading"
      >
      <v-card style="padding:10px">
        <v-row   v-for="riga in righe" :key="riga.IdAllegato" >
          <v-col  align="left" class="font-weight-light" style ="font-size:1.1em;">{{riga.Descrizione}}  </v-col>
          <!-- <v-col  align="left" class="font-weight-light" style ="font-size:1.1em;">{{riga.Stato}}  </v-col>-->
          <v-col  align="right" class="font-weight-light" style ="font-size:1.1em;">{{(riga.Importo/100).toFixed(2)}} €  </v-col>
          <v-col  align="right" class="font-weight-light" style ="font-size:1.1em;" >
            <v-btn :href="riga.Url" color="green" v-if="riga.Confermata=='0'"><v-icon color="white">mdi-credit-card-outline</v-icon></v-btn> 
            <v-icon color="green" v-if="riga.Confermata=='1'">mdi-check-all</v-icon>
            </v-col>
 
        </v-row>
      </v-card>
      <v-card style="padding:10px" v-if="righe.length == 0">
        <h3>Non ci sono pagamenti sospesi</h3>
      </v-card>

        </v-skeleton-loader>

        


    </v-container>
</template>
<script>
export default {
       data: () => ({
           righe:[],
           loading:false
       }),
       computed:{
            importo_da_pagare(){
                let t =0;
                for (let index = 0; index < this.righe.length; index++) {
                    const element = this.righe[index];
                    t+= element.Totale;
                    
                }
                return t;
            }
       },
    methods: {
    getpags: function() {
      this.loading = true
      console.log("AVVIO DOCUMENTI")
      const payload = {
        Comando: "GetElencoTransazioni",
      };
      console.log(payload);
      const me = this;
      this.$store.dispatch("APIRequestHR", payload).then(risp => {
        
        this.loading = false
        if (risp.statusText == "OK") {
          me.righe = risp.data.RISULTATOJSON.ElencoTransazioni;
        }
        console.log(risp,this.loading);
      });
    }
  },
       mounted() {
           this.getpags()
       },
}
</script>